<template>
  <v-row justify="center" class="d-flex flex-row">
    <v-card
      class="ma-2 rounded-xl"
      max-width="300"
      v-for="framework in frameworks"
      :key="framework.name"
    >
      <v-card-text>
        <v-container>
          <v-row justify="center" class="d-flex flex-row text-no-wrap">
            <v-col cols="5" class="text-center">
              <p class="text-h5 text--primary">
                {{ framework.name }}
              </p>
              <p>経験年数：{{ framework.years }}年</p>
            </v-col>
            <v-img
              max-height="100"
              max-width="100"
              :src="framework.src"
              class="mx-auto"
              contain
            ></v-img>
          </v-row>
          <v-row class="my-2">
            <v-divider></v-divider>
          </v-row>
          <v-row justify="center" class="d-flex flex-row mt-5">
            <v-rating
              background-color="gray lighten-3"
              color="gray"
              large
              half-increments
              readonly
              length="5"
              :value="framework.value"
            ></v-rating>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn text color="primary accent-4" @click="framework.judge = true">
          詳細はこちら
        </v-btn>
      </v-card-actions>

      <v-expand-transition>
        <v-card
          v-if="framework.judge"
          class="transition-fast-in-fast-out v-card--reveal"
          style="height: 100%"
        >
          <v-card-text class="pb-0">
            <p class="text-h4 text--primary">{{ framework.name }}</p>

            <p class="no-wrap">{{ framework.detail }}</p>
          </v-card-text>
          <v-card-actions class="d-flex align-content-end flex-wrap">
            <v-btn text color="primary accent-4" @click="framework.judge = false">
              閉じる
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-expand-transition>
    </v-card>
  </v-row>
</template>

<script>

export default {
  data: () => ({
    frameworks: [
      {
        name: "Bootstrap",
        years: "4",
        value: "3",
        judge: false,
        src: require("@/assets/img/framework/bootstrap.png"),
        detail: `編集中 順次追加予定`,
      },
      {
        name: "jQuery",
        years: "3",
        value: "3.5",
        judge: false,
        src: require("@/assets/img/framework/jQuery.png"),
        detail: `編集中 順次追加予定`,
      },
      {
        name: "Vue",
        years: "3",
        value: "3.5",
        judge: false,
        src: require("@/assets/img/framework/Vue.png"),
        detail: `副業での稼ぎ頭。\nAPIを用いた設計やバックエンドにDjangoなど別フレームワークと組み合わせた設計経験有。`,
      },
      {
        name: "django",
        years: "3",
        value: "3",
        judge: false,
        src: require("@/assets/img/framework/django.png"),
        detail: `編集中 順次追加予定`,
      },
      {
        name: "Vuetify",
        years: "3",
        value: "3",
        judge: false,
        src: require("@/assets/img/framework/Vuetify.png"),
        detail: `Vue利用時は大体利用。ポートフォリオサイトもVuetifyで調整`,
      },
    ],
  }),
};
</script>

<style>
.v-card--reveal {
  bottom: 0;
  opacity: 1 !important;
  position: absolute;
  width: 100%;
}

.no-wrap {
  white-space: pre-wrap;
  word-wrap: break-word;
}

</style>